const pagination = {
  dense: "Dense",
  rows_per_page: "Lines per page",
  on: "on",
};
export default pagination;
